import React from "react";
import Layout from '../components/layout'
import { graphql } from "gatsby"
import Contact from '../components/Contact'
import Helmet from 'react-helmet'
import Footer from '../components/Footer'
class AboutTemplate extends React.Component{
  render(){
    const page = this.props.data.contact;

    return (
      <Layout pageType="contact" location={this.props.location}>
        <Helmet title={`${page.title} | Creative Portrait Photographer | Clair Estelle`} /> 
        <main>
          <div className="home-wrapper">
            <div className="contact-content">
              <div class="contact-left" dangerouslySetInnerHTML={{ __html: page.content }} />
              <div class="contact-right">
                <h2>{page.title}</h2>
                <div dangerouslySetInnerHTML={{ __html: page.rightContent }} />
                <Contact />
              </div>
            </div>
          </div>
          <Footer />
        </main>
        <div className="sidebar-right">
            <div dangerouslySetInnerHTML={{ __html: page.sideBarContent }} />
        </div>  
      </Layout>
    );
  }
};

export default AboutTemplate

export const query = graphql`
  query($slug: String!) {
    contact(slug: { eq: $slug }) {
      title,
      content,
      rightContent,
      sideBarContent
    }
  }
`;